import { connect } from 'react-redux';
import { updateSort } from './worklist-actions';
import FilterBar from '../components/toolbar/worklist-toolbar';

const mapStateToProps = state => ({
  activeSort: state.worklist.activeSort,
  activeFilters: state.worklist.activeFilters,
  filters: state.worklist.filterDefinitions,
});

const mapDispatchToProps = {
  updateSort,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);
